<mat-drawer-container class="drawer-container" autosize>
  <div class="scroll">
    <div class="border">
      <div class="header">
        <div class="header-item"><b>Účtový rozvrh: </b></div>
        <div class="header-item">Účetní jednotka: {{ uj }}</div>
        <div class="header-item">Účetní období: {{ uo }}</div>
      </div>
    </div>
    <cml-collection></cml-collection>
  </div>
  <mat-drawer #drawer mode="side" position="end" [disableClose]="true" [opened]="showSideNav$ | async"
    [ngStyle]="getWidth()">

    <router-outlet></router-outlet>
  </mat-drawer>
</mat-drawer-container>